// all application settings
var Settings = {
    parseAppId: 'devmultiapp',
    parseKey: '',
    parseUrl: 'https://devmultiapp.herokuapp.com/parse',
    deepLinkUrl: '',
    privacityPoliticsURL: 'https://www.shogunmonitor.com/documents/SHOGUN%20LINEA%20ETICA-%20POLITICAS%20DE%20PRIVACIDAD%202020.pdf',
    blockscreenshot: false,
    shogunmonitorapp: true,
    login: false,
    footer: {
      active: true,
      dacor: false,
      links: [
        {
          defaultText: "Política de cookies",
          url: "https://www1.shogunmonitor.com/privacy-policies/cookies-policy.html"
        },
        {
          defaultText: "Política de privacidad",
          url: "https://www1.shogunmonitor.com/privacy-policies/privacy-policy.html"
        },
      ]
  }

};

export const LanguageDefault = { "es" :
  {
    "AcceptBtn":"ACEPTAR",
    "AccepttermsSubtittle":"Cuenta con servicio premium, para continuar con tu reporte puedes realizarlo desde",
    "AccepttermsSubtittle2":"o descargando la app de la organización",
    "AttachBtn":"Adjuntar archivo, imagen o video",
    "Attachfilesreport":"Archivos adjuntos:",
    "BackBtn":"Regresar",
    "Btn_back":"Regresar",
    "Btn_home":"Inicio",
    "Btn_NewsBack":"Regresar",
    "CheckAttachedFile":"ver enlace adjunto",
    "CheckboxText":"He leído y acepto los Términos y Condiciones de Uso",
    "Comment_send":"Enviar",
    "Conferencistas_conferencistas":"Conferencistas",
    "ConsultBtn":"Consultar",
    "CreateCommentPlaceHolder":"Realice un comentario",
    "CreateCommentThks":"Gracias",
    "CreateCommentThksMessage":"Su comentario es valioso para mejorar nuestros procedimientos y nuestra comunidad",
    "CreateCommentTittle":"Comentar reporte",
    "CreateReport":"Creando Reporte",
    "DescPlaceHolder":"¿Qué desea denunciar?",
    "Descriptionmsg":"Favor Ingrese la descripción",
    "Filetolarge":"El archivo es muy grande para subir al sistema, favor subir un archivo menor a 80mb",
    "Home_Conferencistas":"Conferencistas",
    "Home_News":"Noticias",
    "Home_Patrocinadores":"Patrocinadores",
    "Home_Programa":"Programa",
    "InfoText":"Ayuda a mejorar tu empresa notificando sobre problemas que hay en esta",
    "InfoText2":"Utilice la herramienta del buscador para encontrar su empresa o institución",
    "InfoText3":"Seleccione empresa o institución",
    "InsertDetailsReportTittle":"Realizar un reporte sobre",
    "inputsearchcode":"Buscar....",
    "LocalizationModalTittle":"Seleccione un lenguaje",
    "MainTittle":"Línea de Transparencia",
    "MakeQuestionClapfo":"REALIZAR REPORTE",
    "Modal2btn":"Atrás",
    "MyReportsBtn":"Mis reportes",
    "MyReportsModalInfo":"Estos son los códigos de reportes que ha realizado, seleccione para consultar.",
    "MyReportsModalTittle":"Mis Reportes",
    "NewReportBtn":"Realizar Pregunta",
    "NewReportForCat":"Crear reporte o denuncia de",
    "News_news":"Noticias",
    "OptionalText":"* Este campo es opcional",
    "Placeholder-home":"Consultar reporte con código",
    "PushNews":"Nueva Noticia",
    "PushRepTitle":"Nuevo",
    "PushSeeMore":"Ver Más",
    "PushSeeReport":"Ver reporte",
    "ReportActivity":"Reporta una actividad",
    "ReportCommentAdmin":"Administrador:",
    "ReportCommentAnonymous":"Usuario Anónimo:",
    "ReportCommentsTittle":"Comentarios sobre el reporte o denuncia:",
    "ReportDays1":"Creado hace",
    "ReportDays2":"días",
    "ReportDescription":"Si desea interponer formalmente su Reclamo, queja o sugerencia, deberá firma su hoja de reclamación en la filial de su preferencia, ubicada a nivel nacional.",
    "ReportDetailSubTittle":"Descripción del reporte o denuncia:",
    "ReportDetailTittle":"Estatus del reporte",
    "ReportNewComment":"Crear comentario",
    "ReportStatus1":"En proceso",
    "ReportStatus2":"Cerrado",
    "ReportStatus3":"Descartado",
    "search":"Seleccione empresa o institución",
    "SelectCategory":"Seleccione empresa o institución",
    "Selectprogram":"Ayuda a mejorar tu empresa notificando sobre problemas que hay en esta",
    "SendBtn":"Enviar",
    "Singlenews_singlenews":"Noticias",
    "SubsidiaryBtn":"Ingresar a Filial Electrónica",
    "Termnstittle":"Términos y Condiciones de Uso",
    "ThksInfo":"Se ha generado un nuevo caso. Para seguirlo sería por medio del siguiente código:",
    "ThksTittle":"Gracias por su reporte o denuncia",
    "UserNameReportHolder":"Nombre del denunciante*",
    "WarningTittle":"Aviso",
    "btnback":"Atrás",
    "btnconferencistasback":"Atrás",
    "Selectprogram2":"Ayuda a mejorar tu empresa notificando sobre problemas que hay en esta",
    "Termsbtn":"Términos y Condiciones de Uso",
    "Selectprogramsub":"categoría",
    "CopyBtn":"Copiar",
    "CopiedBtn":"Copiado"
  }
}

export default Settings;
